import {
  ArrayFormField,
  FormField,
  FormFieldType,
  StagedFieldsGroupFormField,
} from '../typings';
import { getFieldIdWithoutIndex } from '../utils';
import { StringRecord } from '@/typings';
import _ from 'lodash';
import { useEffect, useState } from 'react';

type FormFieldsWithIndex = ArrayFormField | StagedFieldsGroupFormField;

const getFieldsWithIndex = (field: FormField): FormFieldsWithIndex[] => {
  const fieldsWithIndex: Array<FormFieldsWithIndex> = [];

  if (field.naDetails) {
    fieldsWithIndex.push(...getFieldsWithIndex(field.naDetails));
  }

  switch (field.type) {
    case FormFieldType.Array:
    case FormFieldType.StagedFieldsGroup:
      fieldsWithIndex.push(field as FormFieldsWithIndex);
      break;

    case FormFieldType.FieldsGroup:
      for (const f of field.fields) {
        fieldsWithIndex.push(...getFieldsWithIndex(f));
      }
      break;

    case FormFieldType.QuestionWithDetails:
      if (field.trueDetails) {
        fieldsWithIndex.push(...getFieldsWithIndex(field.trueDetails));
      }

      if (field.falseDetails) {
        fieldsWithIndex.push(...getFieldsWithIndex(field.falseDetails));
      }
      break;
  }

  return fieldsWithIndex;
};

export const useFieldsGroupItemCount = (formData: FormField[]) => {
  const [maxItems, setMaxItems] = useState<
    StringRecord<{ maxItem: number; id: string }>
  >({});

  useEffect(() => {
    const fieldsWithIndex: Array<FormFieldsWithIndex> = [];

    for (const field of formData) {
      fieldsWithIndex.push(...getFieldsWithIndex(field));
    }

    const currentMaxItems = fieldsWithIndex.reduceRight((acc, field) => {
      const fieldId = getFieldIdWithoutIndex(field.fieldId);
      if (acc[fieldId] === undefined) {
        acc[fieldId] = {
          maxItem: field.index!,
          id: `${fieldId}_$${field.index!}`,
        };
      } else {
        const maxItem = Math.max(acc[fieldId].maxItem, field.index!);
        acc[fieldId] = { maxItem, id: `${fieldId}_$${maxItem}` };
      }
      return acc;
    }, {} as StringRecord<{ maxItem: number; id: string }>);

    if (!_.isEmpty(currentMaxItems)) {
      setMaxItems(prev => ({ ...prev, ...currentMaxItems }));
    }
  }, [formData]);

  return maxItems;
};
